<div class="row" style="">
  <div *ngIf="!successIcon" style="width: 100%; height: 100%; margin-right: 10px;" class="col-md-3">
    <input type="file" #file placeholder="Choose file" (change)="uploadFile(file.files)" style="display:none;">
    <button type="button" class="btn btn-warning" (click)="file.click()"><i style="font-size:20px" class="fa fa-cloud-upload"></i></button>
  </div>
  <div *ngIf="successIcon" style="width: 100%; height: 100%; margin-right: 10px;" class="col-md-3">
    <input type="file" #file placeholder="Choose file" (change)="uploadFile(file.files)" style="display:none;">
    <button type="button" class="btn btn-success" (click)="file.click()"><i style="font-size:20px" class="fa fa-check"></i></button>
  </div>
  <div class="col-md-4" *ngIf="showUploadMessage">
    <span class="upload" *ngIf="progress > 0">
      {{progress}}%
    </span>
    <span class="upload" *ngIf="message">
      {{message}}
    </span>
  </div>
</div> 
